import React from 'react';
import { Route, withRouter } from 'react-router';
import SegmapList from "./components/segmapList";
// import SegmapForm from "./components/segmapForm";
import SegmapFormWrapper from './form';


const Segmap = () => {
    return (
        <>
            <Route path="/segmap/list" component={withRouter(SegmapList)} />
            <Route path="/segmap/edit/:id" component={SegmapFormWrapper} />
            <Route path="/segmap/clone/:id" component={SegmapFormWrapper} />
            <Route path="/segmap/create" component={SegmapFormWrapper} />
        </>
    )
};

export default Segmap;

